import React, { useEffect, useState } from 'react';
import { FileImageOutlined } from '@ant-design/icons';

// A note's image with a graceful fallback: no URL (most seed notes) or a URL whose object is gone
// (a legacy prod bug left 404 URLs) renders a grey box with the image icon instead of a broken <img>.
// After the first load failure the <img> is dropped altogether, so a bad URL is never retried.
export function NoteImage({ src, alt, width, height }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <span
        role="img"
        aria-label={alt}
        data-testid="note-image-placeholder"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width,
          height: height || Math.round(width * 0.66),
          background: '#f0f0f0',
          color: '#bfbfbf',
          borderRadius: 2,
          fontSize: Math.max(16, Math.round(width * 0.4)),
        }}
      >
        <FileImageOutlined />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      onError={() => setFailed(true)}
    />
  );
}
